<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 动态按钮生成 -->
		<div class="content_edit">
			<pre-btn-Excel @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>
		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<div v-if="item.sel>0 && item.type == 'text'">
					<label>{{item.name}}:</label>
					<input type="text" :class="[item.class==''?'long1':item.class]" v-model="item.val"
						@keyup.enter="refresh_data" />
				</div>
				<div v-else-if="item.sel>0 && item.type == 'select'" :id="item.slot">
					<label>{{item.name}}:</label>
					<input type="text" :class="[item.class==''?'short0':item.class]" v-model="item.sel_name"
						@keyup="select_change(item)" />
					<slot :name="item.slot"></slot>
				</div>
				<div v-else-if="item.sel>0 && item.type == 'date'">
					<label>{{item.name}}:</label>
					<el-date-picker v-model="item.val" type="date" :class="[item.class==''?'short0':item.class]"
						value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>
				</div>
			</div>
			<div class="content_edit_item" v-show="file_show">
				<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
			</div>
		</div>

		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="d_parm" :api_url="d_sel_action"
			:api_action="d_upd_action" />

		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header last-two-none">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[1].val" @click="sel_row(user.item)" @dblclick="edit_data" class="last-two-none">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<a href="#">{{d.val}}</a>
					</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 弹窗编辑 start -->
		<div v-show="show_tan" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_tan_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload" v-loading="element_loading" element-loading-text="拼命加载中......"
					element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
					<div class="pre_leve_one">
						<h3 class="cen">{{title}}</h3>
						<!-- 操作按钮生成 -->
						<div class="content_edit">
							<div class="content_edit_item" v-show="show_btn">
								<pre-button @button-event="select_method" :pre_control="control" />
							</div>
							<div class="content_edit_item" v-show="show_btn_ok">
								<button class="pre_btn_ok" @click="fun_upd('_bad')">
									作废
								</button>
								<button class="pre_btn_ok" @click="fun_look_file()">
									预览文件
								</button>
							</div>
							<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
								<h3 class="red">
									{{sheet_flag}}
								</h3>
							</div>
						</div>
						<!-- 这里放主单据编辑内容-->
						<div class="content_edit">
							<div class="content_edit_item" v-for="(item,index) in parm" :key="index">
								<div v-if="item.type == 'text'">
									<label>{{item.name}}:</label>
									<input type="text" :class="[item.class==''?'short0':item.class]" v-model="item.val"
										@keyup.enter="go_main" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'number'">
									<label>{{item.name}}:</label><input type="number"
										:class="[item.class==''?'short0':item.class]" v-model="item.val" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'date'">
									<label>{{item.name}}:</label>
									<el-date-picker v-model="item.val" type="date"
										:class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
										placeholder="选择日期">
									</el-date-picker>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'select'" :id="item.slot">
									<label>{{item.name}}:</label>
									<input type="text" :class="[item.class==''?'short0':item.class]"
										v-model="item.sel_name" @change="select_change(item)" />
									<slot :name="item.slot"></slot>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'none'">
									<input type="text" v-show="false" v-model="item.val" />
								</div>
								<div v-else-if="item.type == 'readonly'">
									<label>{{item.name}}:</label><input type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.val"
										readonly="readonly" />
									<em>*</em>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'radio'">
									<el-radio-group v-model="radio" size="mini" @change="fun_option(item)">
										<el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id" border>
											{{d.name}}
										</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div class="content_edit_item" v-show="file_show">
								<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
							</div>
						</div>
					</div>

					<div class="pre_leve_two">
						<div v-show="show_d1">
							<!-- 明细---项目名称 -->
							<h5 v-show="show_detail_content" class="cen pretop">{{d1_title_name}}</h5>
							<!-- 明细---项目名称  编辑区域 -->
							<div v-show="show_detail_content" class="content_edit">
								<div class="content_btn_row">
									<div class="content_btn">
										<div class="content_btn_item">
											<button class="pre_btn_ok" @click="fun_d1_load()">
												查询
											</button>
											<button class="pre_btn_ok" @click="fun_d1_clear()">
												清空
											</button>
											<button class="pre_btn_ok" @click="fun_d1_update('_add')">
												增加
											</button>
											<button class="pre_btn_ok" @click="fun_d1_update('_upd')">
												修改
											</button>
										</div>
									</div>
								</div>
								<div class="content_edit_item" v-for="(item,index) in d1_parm" :key="index">
									<div v-if="item.type == 'text'">
										<label>{{item.name}}:</label>
										<input type="text" :id="[item.first=='isfirst'?'isfirst_1':'no'+GetRandom()]"
											:class="[item.class==''?'short0':item.class]" v-model="item.val"
											@keyup.enter="fun_d1_update('_add')" />
										<em v-show="item.weight=='1'">*</em>
										<em v-show="item.weight==''"></em>
									</div>
									<div v-else-if="item.type == 'number'">
										<label>{{item.name}}:</label>
										<input type="number" :class="[item.class==''?'short0':item.class]"
											v-model="item.val" @keyup.enter="fun_d1_update('_add')" />
										<em v-show="item.weight=='1'">*</em>
										<em v-show="item.weight==''"></em>
									</div>
									<div v-else-if="item.type == 'date'">
										<label>{{item.name}}:</label>
										<el-date-picker v-model="item.val" type="date"
											:class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
											placeholder="选择日期">
										</el-date-picker>
										<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
									</div>
									<!-- <div v-else-if="item.type == 'select'" :id="item.slot">
                    <label>{{item.name}}:</label>
                    <input :id="[item.first=='isfirst'?'isfirst':'no'+GetRandom()]" type="text"
                      :class="[item.class==''?'short0':item.class]" v-model="item.sel_name"
                      @keyup="select_change(item)" />
                    <slot :name="item.slot"></slot>
                    <em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
                  </div> -->
									<div v-else-if="item.type == 'none'">
										<input type="text" v-show="false" v-model="item.val" />
									</div>
									<div v-else-if="item.type == 'readonly'">
										<label>{{item.name}}:</label>
										<input type="text" :class="[item.class==''?'short0':item.class]"
											v-model="item.val" readonly="readonly" />
										<em>*</em>
										<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
									</div>
									<!-- <div v-else-if="item.type == 'radio'">
                    <el-radio-group v-model="item.val" size="mini">
                      <el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id"
                        @change="fun_option_d(item,d.id)" border>{{d.name}}</el-radio>
                    </el-radio-group>
                  </div> -->
								</div>
							</div>
							<!-- 明细---项目名称  展示区 -->
							<div v-show="show_detail_content" id="pre_tab" class="pre_tab">
								<table class="pre_tb_detail" border="1" cellpadding="2" cellspacing="1">
									<tr class="tab_header">
										<td v-for="(t,index) in d1_name" :key="index">{{t.name}}</td>
										<td v-show="show_detail_action">操作</td>
									</tr>
									<tr v-for="data_tr in d1_detail" @click="fun_d1_sel(data_tr)">
										<!-- <a href="#"> -->
										<td v-for="(d,index) in data_tr" :key="index"
											v-on:mousemove="show_detaildata($event, d.val, '1')"
											v-on:mouseout="noshow_detaildata">
											<a href="#">{{d.val}}</a>
										</td>
										<!-- </a> -->
										<td v-show="show_detail_action">
											<!-- <span @click="fun_d1_upd('_upd')">
                      <i class="iconfont icon-bianji"></i>修改
                    </span> -->
											<span @click="fun_d1_update('_del',data_tr)">
												<i class="iconfont icon-shanchu"></i>删除
											</span>
										</td>
									</tr>
								</table>
							</div>
						</div>

						<div v-show="show_d2">
							<!-- 明细---项目名称 -->
							<h5 v-show="show_detail_content" class="cen pretop">{{d2_title_name}}</h5>
							<!-- 明细---项目名称  编辑区域 -->
							<div v-show="show_detail_content" class="content_edit">
								<div class="content_btn_row">
									<div class="content_btn">
										<div class="content_btn_item">
											<button class="pre_btn_ok" @click="fun_d2_load()">
												查询
											</button>
											<button class="pre_btn_ok" @click="fun_d2_clear()">
												清空
											</button>
											<button class="pre_btn_ok" @click="fun_d2_update('_add')">
												增加
											</button>
											<button class="pre_btn_ok" @click="fun_d2_update('_upd')">
												修改
											</button>
										</div>
									</div>
								</div>
								<div class="content_edit_item" v-for="(item,index) in d2_parm" :key="index">
									<div v-if="item.type == 'text'">
										<label>{{item.name}}:</label>
										<input type="text" :id="[item.first=='isfirst'?'isfirst_2':'no'+GetRandom()]"
											:class="[item.class==''?'short0':item.class]" v-model="item.val"
											@keyup.enter="fun_d2_update('_add')" />
										<em v-show="item.weight=='1'">*</em>
										<em v-show="item.weight==''"></em>
									</div>
									<div v-else-if="item.type == 'number'">
										<label>{{item.name}}:</label>
										<input type="number" :class="[item.class==''?'short0':item.class]"
											v-model="item.val" @keyup.enter="fun_d2_update('_add')" />
										<em v-show="item.weight=='1'">*</em>
										<em v-show="item.weight==''"></em>
									</div>
									<div v-else-if="item.type == 'date'">
										<label>{{item.name}}:</label>
										<el-date-picker v-model="item.val" type="date"
											:class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
											placeholder="选择日期">
										</el-date-picker>
										<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
									</div>
									<!-- <div v-else-if="item.type == 'select'" :id="item.slot">
                    <label>{{item.name}}:</label>
                    <input :id="[item.first=='isfirst'?'isfirst':'no'+GetRandom()]" type="text"
                      :class="[item.class==''?'short0':item.class]" v-model="item.sel_name"
                      @keyup="select_change(item)" />
                    <slot :name="item.slot"></slot>
                    <em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
                  </div> -->
									<div v-else-if="item.type == 'none'">
										<input type="text" v-show="false" v-model="item.val" />
									</div>
									<div v-else-if="item.type == 'readonly'">
										<label>{{item.name}}:</label>
										<input type="text" :class="[item.class==''?'short0':item.class]"
											v-model="item.val" readonly="readonly" />
										<em>*</em>
										<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
									</div>
									<!-- <div v-else-if="item.type == 'radio'">
                    <el-radio-group v-model="item.val" size="mini">
                      <el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id"
                        @change="fun_option_d(item,d.id)" border>{{d.name}}</el-radio>
                    </el-radio-group>
                  </div> -->
								</div>
							</div>
							<!-- 明细---项目名称  展示区 -->
							<div v-show="show_detail_content" id="pre_tab" class="pre_tab">
								<table class="pre_tb_detail" border="1" cellpadding="2" cellspacing="1">
									<tr class="tab_header">
										<td v-for="(t,index) in d2_name" :key="index">{{t.name}}</td>
										<td v-show="show_detail_action">操作</td>
									</tr>
									<tr v-for="data_tr in d2_detail" @click="fun_d2_sel(data_tr)">
										<!-- <a href="#"> -->
										<td v-for="(d,index) in data_tr" :key="index"
											v-on:mousemove="show_detaildata($event, d.val, '1')"
											v-on:mouseout="noshow_detaildata">
											<a href="#">{{d.val}}</a>
										</td>
										<!-- </a> -->
										<td v-show="show_detail_action">
											<span @click="fun_d2_update('_del',data_tr)">
												<i class="iconfont icon-shanchu"></i>删除
											</span>
										</td>
									</tr>
								</table>
							</div>
						</div>

						<!-- 这里放明细单据内容 -->
						<h5 v-show="show_detail_content" class="cen pretop">{{d_title_name}}</h5>
						<!-- 明细部分编辑区 -->
						<div v-show="show_detail_content" class="content_edit">
							<div class="content_btn_row">
								<div class="content_btn">
									<div class="content_btn_item">
										<button class="pre_btn_ok" @click="fun_d_load()">
											查询
										</button>
										<button class="pre_btn_ok" @click="fun_d_clear()">
											清空
										</button>
										<button class="pre_btn_ok" @click="fun_d_update('_add')">
											增加
										</button>
										<button class="pre_btn_ok" @click="fun_d_update('_upd')">
											修改
										</button>
									</div>
								</div>
							</div>
							<div class="content_edit_item" v-for="(item,index) in d_parm" :key="index">
								<div v-if="item.type == 'text'">
									<label>{{item.name}}:</label>
									<input :id="[item.first=='isfirst'?'isfirst':'no'+GetRandom()]" type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.val"
										@keyup.enter="fun_d_update('_add')" />
									<em v-show="item.weight=='1'">*</em>
									<em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'number'">
									<label>{{item.name}}:</label>
									<input type="number" :class="[item.class==''?'short0':item.class]"
										v-model="item.val" @keyup.enter="fun_d_update('_add')" />
									<em v-show="item.weight=='1'">*</em>
									<em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'date'">
									<label>{{item.name}}:</label>
									<el-date-picker v-model="item.val" type="date"
										:class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
										placeholder="选择日期">
									</el-date-picker>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'select'" :id="item.slot">
									<label>{{item.name}}:</label>
									<input :id="[item.first=='isfirst'?'isfirst':'no'+GetRandom()]" type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.sel_name"
										@keyup="select_change(item)" />
									<slot :name="item.slot"></slot>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'none'">
									<input type="text" v-show="false" v-model="item.val" />
								</div>
								<div v-else-if="item.type == 'readonly'">
									<label>{{item.name}}:</label>
									<input type="text" :class="[item.class==''?'short0':item.class]" v-model="item.val"
										readonly="readonly" />
									<em>*</em>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'radio'">
									<el-radio-group v-model="item.val" size="mini">
										<el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id"
											@change="fun_option_d(item,d.id)" border>{{d.name}}</el-radio>
									</el-radio-group>
								</div>
							</div>
							<!-- <div class="content_edit_item" v-show="file_show">
                <label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
              </div> -->
						</div>
						<!-- 明细部分展示区 -->
						<div v-show="show_detail_content" id="pre_tab" class="pre_tab">
							<table class="pre_tb_detail" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header">
									<td v-for="(t,index) in d_name" :key="index">{{t.name}}</td>
									<td v-show="show_detail_action">操作</td>
								</tr>
								<tr v-for="data_tr in d_detail" @click="fun_d_sel(data_tr)">
									<!-- <a href="#"> -->
									<td v-for="(d,index) in data_tr" :key="index"
										v-on:mousemove="show_detaildata($event, d.val, '1')"
										v-on:mouseout="noshow_detaildata">
										<a href="#">{{d.val}}</a>
									</td>
									<!-- </a> -->
									<td v-show="show_detail_action">
										<span @click="fun_d_update('_del',data_tr)">
											<i class="iconfont icon-shanchu"></i>删除
										</span>
									</td>
								</tr>
							</table>
						</div>

					</div>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<prefilelist ref="myfilelist" @filelist-event="refresh_data" />

	</div>
</template>

<script>
	/*
单条业务超过10个字段用此模板
名称：通用基础模板2.0
日期：2021-03-31 主表+三张明细表
作者：hj
目标：
方法 传入参数，
1、主界面固定按钮:查询、新建、备注说明,权限控制 导入和导出。
2、弹窗编辑界面:通过权限控制 查询、增加、删除、修改、提交、导入、导出、文件操作。
3、通过sel 来确定 查询标签。通过bold 来确定 必填项。
4、弹窗界面 一次性完成 主单据+明细单据保存。
5、主单据功能: 分页查询+通用编辑+table 可以换行
    明细功能: 单页查询+通用编辑方法+文件
6、隐藏首列ID,固定隐藏明细部分倒数第2、3列、为需要传值但是又不能显示出来的预留
*/

	import api from '@/utils/type.js';
	import {
		Select_PageLength,
		Method_Common,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	export default {
		name: "pre_base_table_3",
		components: {
			"pre-button": () => import("./pre_btn_control_tan_newfile.vue"),
			"pre-btn-Excel": () => import("./pre_btn_control_newfile.vue"),
			"pre-table": () => import("../auto/old_view_table.vue"),
			'per-exceldown': () => import("../auto/auto_excel_down.vue"),
			'per-excelup': () => import("./pre_excel_up_new.vue")
		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				bak_data: '', //防止重复操作记录
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,
				show_btn_ok: false,

				parm: [], //参数结构
				parm_sel: [],
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				// 弹窗编辑
				show_tan: false,

				// 费用-明细部分参数
				show_detail_content: false,
				show_detail_action: false,
				d_title_name: '',
				d_load_url: '',
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据
				/* 明细 -项目 */
				show_d1: false,
				d1_title_name: '',
				d1_sel_action: '',
				d1_upd_action: '',
				d1_row_id: '',
				d1_sys_date: '',
				d1_parm: [], //明细参数构造
				d1_name: [], //明细标题
				d1_detail: [], //明细数据
				/* 明细 -配件 */
				show_d2: false,
				d2_title_name: '',
				d2_sel_action: '',
				d2_upd_action: '',
				d2_row_id: '',
				d2_sys_date: '',
				d2_parm: [], //明细参数构造
				d2_name: [], //明细标题
				d2_detail: [], //明细数据

				// 备注
				detail_data: '',
				//文件
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_action: '',
				p1: '',
				p2: '',
				p3: '',

				// 组件按钮权限获取
				sel_from: 'm',
				filelist_control: {}

			};
		},
		props: {
			pre_data: {
				type: String,
				default: ''
			}
		},
		watch: {
			pre_data(val) {
				if (val.length > 0) {
					this.load_data();
				}
			},
			sheet_no(val) {
				if (typeof(val) != "undefined" && val != '') {
					this.show_detail_content = true;
				} else {
					this.show_detail_content = false;
				}
			},
			sheet_flag(val) {
				if (val == '已提交') {
					this.show_detail_action = false;
				} else {
					this.show_detail_action = true;
				}
			}
		},
		mounted: function() {
			if (this.pre_data != '') {
				let that = this;
				this.$nextTick(function() {
					this.load_data();
				});
			}
		},
		methods: {
			fun_file_list: function(sheet_no, id, flag, f_url, f_src, tf) {
				// console.log('当前附件集组件权限', this.filelist_control);
				if (typeof(this.filelist_control.isok) === 'undefined') {
					// console.log('正在校验附件集组件操作权限,请等待');
					this.$message({
						message: '正在校验附件集组件操作权限,请等待',
						type: 'warning'
					});
					return;
				}
				if (this.filelist_control.isok == '0') {
					// console.log('您没有附件集组件的操作权限!');
					this.$message({
						message: this.filelist_control.msg,
						type: 'warning'
					});
					return;
				}

				let p = {};
				p.title = this.title;
				p.file_action = this.file_action;
				p.p1 = this.p1;
				p.p2 = this.p2;
				p.p3 = this.p3;

				p.file_src = f_src;
				p.file_url = f_url;

				p.sheet_no = sheet_no;
				p.row_id = id;
				p.sheet_flag = flag;
				p.filelist = tf;

				p.file_up = this.filelist_control.fileup;
				p.file_look = this.filelist_control.filelook;
				p.file_del = this.filelist_control.filedel;

				p.sel_from = this.sel_from;

				this.$refs['myfilelist'].load_data(p);
			},

			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			show_edit: function() {
				// //console.log('弹窗。。。。。');
				if (this.show_tan) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_tan_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_tan_bg").fadeIn("3000");
					$(".pre_tan_conten").fadeIn("3000");

					if (typeof(this.sheet_no) != "undefined" && this.sheet_no != '') {
						if (typeof(this.d1_title_name) != "undefined" && this.d1_title_name != '') {
							this.fun_d1_load();
						}
						if (typeof(this.d2_title_name) != "undefined" && this.d2_title_name != '') {
							this.fun_d2_load();
						}

						this.fun_d_load();
					}
					// //console.log('sheet_no=' + this.sheet_no + ' = ' + this.show_detail_content);

				} else {
					this.closeshow();
				}
			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");
				this.show_tan = false;
				this.$emit('base2-event', 'father');
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {
				// //console.log(this.pre_data);
				let r = JSON.parse(this.pre_data);
				// //console.log(r);
				let that = this;
				this.$nextTick(function() {
					that.title = r.title;
					that.control = r.control;
					that.sel_action = r.sel_action;
					that.upd_action = r.upd_action;
					that.parm = r.parm;
					that.parm_sel = r.parm_sel;
					that.parm_th = r.parm_th;
					that.row_id = '';
					that.sys_date = '';
					that.sheet_no = '';
					that.sheet_flag = '';

					that.d_title_name = r.d_title_name;
					that.d_sel_action = r.d_sel_action;
					that.d_upd_action = r.d_upd_action;
					that.file_action = r.file_action;
					that.p1 = r.p1;
					that.p2 = r.p2;
					that.p3 = r.p3;
					that.d_parm = r.d_parm;
					that.d_name = r.d_name;
					that.d_detail = [];
					that.d_row_id = '';
					that.d_sys_date = '';


					that.d1_title_name = r.d1_title_name;
					that.d1_sel_action = r.d1_sel_action;
					that.d1_upd_action = r.d1_upd_action;
					that.d1_parm = r.d1_parm; //明细参数构造
					that.d1_name = r.d1_name; //明细标题
					that.d1_detail = []; //明细数据
					that.d1_row_id = '';
					that.d1_sys_date = '';
					// //console.log('d1_title_name=' + that.d1_title_name);
					if (typeof(r.d1_title_name) != "undefined" && r.d1_title_name != '') {
						that.show_d1 = true;
					}

					that.d2_title_name = r.d2_title_name;
					that.d2_sel_action = r.d2_sel_action;
					that.d2_upd_action = r.d2_upd_action;
					that.d2_parm = r.d2_parm; //明细参数构造
					that.d2_name = r.d2_name; //明细标题
					that.d2_detail = []; //明细数据
					that.d2_row_id = '';
					that.d2_sys_date = '';
					//console.log('d2_title_name=' + that.d2_title_name);
					if (typeof(r.d2_title_name) != "undefined" && r.d2_title_name != '') {
						that.show_d2 = true;
					}

					that.refresh_data();
					that.sel_from = 'm';
					that.load_power_filelist();
				});
				
			},
			load_power_filelist: function() {
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Method_EasySelect('filelist_power_check', this.control, r)
				).then(res => {
					res = JSON.parse(res);
					let o = {};
					o = res.data.data[0];
					o.msg = res.data.msg;
					this.filelist_control = o;
					// console.log(this.filelist_control);


				});


			},
			select_method: function(type, tfile) {
				// console.log('操作=' + type);
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						this.refresh_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					case 'filelist':
						let temp_id = 0;
						switch (this.sel_from) {
							case 'm':
								temp_id = this.row_id;
								break;
							case 'd':
								temp_id = this.d_row_id;
								break;
							case 't':
								temp_id = this.d1_row_id;
								break;
							default:
								break;
						}
						this.fun_file_list(this.sheet_no, temp_id, this.sheet_flag, this.file_url, this.file_src,
							tfile);

						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			refresh_data: function(type, page, pagelength, backdata) {
				if (typeof(page) === 'undefined' || Number(page) == 0) {
					page = 1;
				}

				if (typeof(pagelength) === 'undefined' || Number(pagelength) == 0) {
					pagelength = 20;
				}

				// console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				this.page_length = pagelength;
				this.nowpage = page;
				// 返回修改成功后的结果。
				// console.log('查询刷新=' + type + ' page=' + page);
				// console.log(' FLAG=' + this.sheet_flag);


				//console.log(backdata);
				if (type == 'upd_ok' || type == 'UPDATE_OK') {
					// 同步关键参数便于后续修改
					let back = JSON.parse(backdata);
					// console.log(back);
					this.sheet_flag = back.msg;
					if (typeof(back.new_id) !== 'undefined' && Number(back.new_id) > 0) {
						this.row_id = back.new_id;
						this.sheet_flag = back.msg;
						// 同步关键参数便于后续修改
						this.sys_date = back.sys_date;
						this.sheet_no = back.sheet_no;

					} else {
						this.row_id = back.keyword.id;
						this.sys_date = back.keyword.sys_date;
					}

					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == 'sheet_no') {
							this.parm[j].val = this.sheet_no;
							// this.sheet_no = back.keyword.sheet_no;
							break;
						}
					}
				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';

				if (this.sheet_flag.indexOf('删除') == 0) {

					this.data_clear();
				} else {
					// 如果作废,切换按钮
					if (this.sheet_flag.indexOf('作废') > 0) {
						this.show_btn = false;
						this.show_btn_ok = true;

					} else {
						this.show_btn = true;
						this.show_btn_ok = false;
					}

					// console.log('查询条件', this.parm_sel);

					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;
								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
						}
					}
				}

				let r = (Math.random() + '').substring(0, 8);

				let that = this;
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Select_PageLength('data_' + that.sel_action, that.nowpage, that
						.page_length, that.kw1, that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, r);
				}, 200)

			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			new_blank: function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;
				this.data_clear();
				this.show_edit();
			},
			edit_data: function() {
				this.show_tan = true;
				this.show_edit();
			},
			sel_row: function(item) {
				// console.log(item);
				// 判断 obj.hasOwnProperty("key")
				this.sel_from = 'm'; //如果使用图片集，切换到主表
				//2、遍历Json串获取其属性
				this.data_clear();
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							if (this.sheet_flag == '盘点完成') {
								this.show_btn = false;
								this.show_btn_ok = true;
							} else {
								this.show_btn = true;
								this.show_btn_ok = false;
							}
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].type == 'select' && this.parm[j].key == item[i].key) {
							this.$emit('base2-event', this.parm[j].slot, item[i].val)
							break;
						} else if (this.parm[j].type == 'radio' && this.parm[j].key == item[i].key) {
							if (item[i].val == '是') {
								this.radio = '1';
							} else {
								this.radio = '0';
							}
							// //console.log(this.radio);
							this.parm[j].val = this.radio;
						} else {
							if (this.parm[j].key == item[i].key) {
								this.parm[j].val = item[i].val;
								break;
							}
						}
					}
				}

				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item, 'select');
				// 切换背景色
				this.$refs.file_table.setCurrentRowJson('m_', item[1].val);
			},
			refesh_parm: function(type, id, val, ismain) {
				// 刷新select菜单参数
				// type 匹配类型, id, val,ismain 刷新主数据还是子数据
				// console.log('组件type=' + type + ' ismain=' + ismain);
				// console.log('id=' + id + ' val=' + val);
				switch (ismain) {
					case 'main':
						for (let j = 0; j < this.parm.length; j++) {
							if (this.parm[j].slot == type) {
								this.parm[j].sel_name = val;
								this.parm[j].val = id;
								break;
							}
						}

						for (let j = 0; j < this.parm_sel.length; j++) {
							if (this.parm_sel[j].slot == type) {
								this.parm_sel[j].sel_name = val;
								this.parm_sel[j].val = id;
								break;
							}
						}
						break;
					case 'children':
						for (let j = 0; j < this.d_parm.length; j++) {
							if (this.d_parm[j].slot == type) {
								this.d_parm[j].sel_name = val;
								this.d_parm[j].val = id;
								break;
							}
						}
						break;
					default:
						this.$message({
							message: 'ismain=' + ismain + ' 没有配置相关操作!',
							type: 'error'
						});
						break;
				}

				// 简易联动 不通用
				if (type == 'slot_c_class') {
					let show_sel_two = false;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'c_class' && this.parm[i].sel_name == '车挂') {
							// //console.log(this.parm[i]);
							show_sel_two = true;
							break;
						}
					}
					// //console.log('show_sel_two='+show_sel_two);
					if (show_sel_two) {
						document.getElementById('slot_c_exp_flag').style.display = 'block';
					} else {
						document.getElementById('slot_c_exp_flag').style.display = 'none';
					}
				}

			},
			fun_option: function(item) {
				// 单选项 参数传值。
				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'radio' && this.parm[j].key == item.key) {
						this.parm[j].val = this.radio;
						break;
					}
				}
			},
			select_change: function(item) {
				let that = this;
				that.$emit('base2-event', item.slot, item.sel_name)
			},
			data_clear: function() {
				// //console.log('清除 历史 参数。。。。');
				this.bak_data = ''; //防止重复操作记录

				this.row_id = '';
				this.sel_item = {}; //备份点击项目
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}
				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}
				}
			},
			fun_upd: function(type) {
				// //console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					// this.parm[0].val = ''; //解决新增后刷新，编号还是以前的导致无法定位新数据。2020-12-28 add
					if (this.parm[1].val == '') {
						this.$message({
							message: this.parm[1].name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					//console.log(this.parm[i].val);
					if (this.parm[i].p)
						d.push(this.parm[i].val);
				}

				if ((type != '_add') && (this.row_id == 0 || this.sys_date == '')) {

				}
				let r = (Math.random() + '').substring(0, 8);
				this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d, r);
				// //console.log(d);
				// let temp_data = '';
				// temp_data = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d);
				// if (this.bak_data == temp_data) {
				//   this.$message({
				//     message: '不能重复操作!',
				//     type: 'warning'
				//   });
				//   return;
				// }
				// // document.getElementById('ismainfirst').focus();
				// this.upd_json = temp_data;
				// this.bak_data = temp_data;
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(item);
				x = that.clientX + 10;
				y = that.clientY;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// //console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 200px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					document.getElementById("pre_msg_data").innerText = BackSpecial(item);
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			go_main: async function() {
				// 保存主数据
				let flag = false;
				flag = await this.check_parm();
				if (flag) {
					return;
				}
				this.fun_upd('_add');
			},
			check_parm: function() {
				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.parm.length; i++) {
						if (that.parm[i].weight == '1' && that.parm[i].val == '') {
							that.$message({
								message: that.title + ': ' + that.parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},

			/****明细部分操作 start***********************************************/
			fun_d_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					}
				}
			},
			fun_d_check: function() {
				//console.log('sheet_no=' + this.sheet_no);
				let nosheet_no = true;
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no') {
						this.d_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'm_id') {
							this.d_parm[i].val = this.row_id;
							break;
						}
					}
				}

				let that = this;
				return new Promise((resolve, reject) => {
					let d = [];
					for (let i = 0; i < that.d_parm.length; i++) {
						switch (that.d_parm[i].key) {
							case 'id':
								that.d_row_id = that.d_parm[i].val;
								break;
							case 'sys_date':
								that.d_sys_date = that.d_parm[i].val;
								break;
							default:
								d.push(that.d_parm[i].val);
								break;
						}
					}
					resolve(d)
				})
			},
			fun_d_sel: function(item) {
				// //console.log('编辑');
				// //console.log(item);
				this.sel_from = 'd'; //如果使用图片集，切换到明细
				
				this.fun_d_clear();
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							} else {
								this.file_show = false;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].type == 'select' && this.d_parm[j].key == item[i].key) {
							this.$emit('base2-event', this.d_parm[j].slot, item[i].val)
							break;
						} else if (this.d_parm[j].type == 'radio' && this.d_parm[j].key == item[i].key) {
							if (item[i].val == '是') {
								this.radio = '1';
							} else {
								this.radio = '0';
							}
							// //console.log(this.radio);
							this.d_parm[j].val = this.radio;
						} else {
							if (this.d_parm[j].key == item[i].key) {
								this.d_parm[j].val = item[i].val;
								break;
							}
						}
					}
				}

			},
			fun_d_load: function() {
				// 加载明细数据
				// //console.log('加载明细数据=' + this.sheet_no);
				// //console.log(this.parm);
				if (this.sheet_no == null || this.sheet_no == '') {
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.sheet_no = this.parm[i].val;
							break;
						}
					}
					//console.log('sheet_no=' + this.sheet_no);
					let nosheet_no = true;
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'sheet_no') {
							this.d_parm[i].val = this.sheet_no;
							nosheet_no = false;
							break;
						}
					}

					//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
					if (nosheet_no) {
						for (let i = 0; i < this.d_parm.length; i++) {
							if (this.d_parm[i].key == 'm_id') {
								this.d_parm[i].val = this.row_id;
								this.sheet_no = this.row_id; //sheet_no 和  row_id 混和，不好这样，下次涉及注意优化
								break;
							}
						}
					}
				}

				this.d_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					return;
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d_sel_action, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						if (Number.parseInt(res.data.status) == 1) {
							this.maxpage = res.data.allpage;
							if (Number(res.data.allpage) == 0) {
								this.$message({
									message: '没有查询到数据',
									type: 'success'
								});
							} else {
								//console.log(res.data.data);
								// this.data_tab = res.data.data;
								let t = res.data.data;
								for (let i = 0; i < t.length; i++) {
									let arr = [];
									for (let j in t[i]) {
										// //console.log('key=' + j);       //输出key
										// //console.log('val=' + t[i][j]); //输出key对应的value
										let o = {};
										o.key = j;
										o.val = t[i][j];
										arr.push(o);
									}
									this.d_detail.push(arr);
								}
							}
						} else {
							this.$message({
								message: this.d_title_name + res.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});


			},
			fun_d_update: async function(type, item) {
				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '单号=' + this.sheet_no + ' 已经提交,不能修改明细!',
						type: 'error'
					});
					return;
				}

				let d = [];
				d = await this.fun_d_check();

				if (type == '_del') {
					await this.fun_d_sel(item);
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}

					let isExistFile = false;
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'f_url' && this.d_parm[i].val != '') {
							isExistFile = true;
							break;
						}
					}
					if (isExistFile) {
						this.$message({
							message: '请先删除附件,再删除数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_upd') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add' || type == '_upd') {
					document.getElementById('isfirst').focus();
				}

				let temp_data = '';
				temp_data = Method_Common('data_' + this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							let that = this;
							setTimeout(function() {
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},
			fun_option_d: function(item, id) {
				// 单选项 参数传值。
				// //console.log(item);
				// //console.log('ID='+id);
				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type == 'radio' && this.d_parm[j].key == item.key) {
						this.d_parm[j].val = id;
						this.$emit('base2-event', 'changlist');
						break;
					}
				}
			},
			/****明细部分操作 end***********************************************/
			/****明细----------项目操作 start***********************************************/
			fun_d1_clear: function() {
				this.d1_row_id = '';
				this.d1_sys_date = '';
				for (let i = 0; i < this.d1_parm.length; i++) {
					this.d1_parm[i].val = '';
				}
			},
			fun_d1_check: function() {
				//console.log('sheet_no=' + this.sheet_no + ' row_id=' + this.row_id);

				let nosheet_no = true;
				for (let i = 0; i < this.d1_parm.length; i++) {
					if (this.d1_parm[i].key == 'sheet_no') {
						this.d1_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d1_parm.length; i++) {
						if (this.d1_parm[i].key == 'm_id') {
							this.d1_parm[i].val = this.row_id;
							break;
						}
					}
				}

				let that = this;
				return new Promise((resolve, reject) => {
					let d = [];
					for (let i = 0; i < that.d1_parm.length; i++) {
						switch (that.d1_parm[i].key) {
							case 'id':
								that.d1_row_id = that.d1_parm[i].val;
								break;
							case 'sys_date':
								that.d1_sys_date = that.d1_parm[i].val;
								break;
							default:
								d.push(that.d1_parm[i].val);
								break;
						}
					}
					resolve(d)
				})
			},
			fun_d1_sel: function(item) {
				//console.log(item);
				

				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d1_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d1_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d1_parm.length; j++) {
						if (this.d1_parm[j].key == item[i].key) {
							this.d1_parm[j].val = item[i].val;
							break;
						}
					}
				}
			},
			fun_d1_load: function() {
				this.d1_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					return;
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d1_sel_action, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (Number.parseInt(res.data.status) == 1) {
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								this.d1_detail.push(arr);
							}
						} else {
							this.$message({
								message: this.d1_title_name + '' + res.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});



			},
			fun_d1_update: async function(type, item) {
				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '单号=' + this.sheet_no + ' 已经提交,不能修改明细!',
						type: 'error'
					});
					return;
				}

				let d = [];
				d = await this.fun_d1_check();

				if (type == '_del') {
					await this.fun_d1_sel(item);
					if (this.d1_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d1_row_id + ' 请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_upd') {
					if (this.d1_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d1_row_id + ' 请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add' || type == '_upd') {
					document.getElementById('isfirst_1').focus();
				}

				let temp_data = '';
				temp_data = Method_Common('data_' + this.d1_upd_action + type, this.d1_row_id, this.d1_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							let that = this;
							setTimeout(function() {
								that.fun_d1_load();
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})
			},

			/****明细----------项目 end***********************************************/

			/****明细----------配件部分操作 start***********************************************/
			fun_d2_clear: function() {
				this.d2_row_id = '';
				this.d2_sys_date = '';
				for (let i = 0; i < this.d2_parm.length; i++) {
					this.d2_parm[i].val = '';
				}
			},
			fun_d2_check: function() {
				let nosheet_no = true;
				for (let i = 0; i < this.d2_parm.length; i++) {
					if (this.d2_parm[i].key == 'sheet_no') {
						this.d2_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d2_parm.length; i++) {
						if (this.d2_parm[i].key == 'm_id') {
							this.d2_parm[i].val = this.row_id;
							break;
						}
					}
				}

				let that = this;
				return new Promise((resolve, reject) => {
					let d = [];
					for (let i = 0; i < that.d2_parm.length; i++) {
						switch (that.d2_parm[i].key) {
							case 'id':
								that.d2_row_id = that.d2_parm[i].val;
								break;
							case 'sys_date':
								that.d2_sys_date = that.d2_parm[i].val;
								break;
							default:
								d.push(that.d2_parm[i].val);
								break;
						}
					}
					resolve(d)
				})
			},
			fun_d2_sel: function(item) {
				this.sel_from = 't'; //如果使用图片集，切换到明细
				// //console.log(item);
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d2_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d2_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.d2_parm.length; j++) {
						if (this.d2_parm[j].key == item[i].key) {
							this.d2_parm[j].val = item[i].val;
							break;
						}
					}
				}
			},
			fun_d2_load: function() {
				this.d2_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					return;
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d2_sel_action, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (Number.parseInt(res.data.status) == 1) {
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								this.d2_detail.push(arr);
							}
						} else {
							this.$message({
								message: this.d2_title_name + '' + res.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});



			},
			fun_d2_update: async function(type, item) {
				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '单号=' + this.sheet_no + ' 已经提交,不能修改明细!',
						type: 'error'
					});
					return;
				}

				let d = [];
				d = await this.fun_d2_check();

				if (type == '_del') {
					await this.fun_d2_sel(item);

					if (this.d2_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d2_row_id + ' 请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_upd') {
					if (this.d2_row_id == 0) {
						this.$message({
							message: 'ID=' + this.d2_row_id + ' 请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add' || type == '_upd') {
					document.getElementById('isfirst_2').focus();
				}

				let temp_data = '';
				temp_data = Method_Common('data_' + this.d2_upd_action + type, this.d2_row_id, this.d2_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							let that = this;
							setTimeout(function() {
								that.fun_d2_load();
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})
			},


			/****明细----------配件部分操作 end***********************************************/
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {

					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;
								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Select_PageLength('data_' + this.sel_action, this.nowpage, this.page_length, this
							.kw1, this.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9)
					});

					this.show_excel = true;
				}
			},
			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 项目名称ID=0</div>请检查!'
					});
					return;
				}

				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				let fileobj = document.getElementById('hetong_file');
				fileobj.click();
			},
			fun_look_file: function() {
				console.log('点击预览附件');
				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}
				console.log(this.file_url);

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {


					// let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(BackSpecial(this.file_url));
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					let temp_src = BackSpecial(BackSpecial(this.file_src));
					let temp_type = temp_filename.substring(temp_filename.lastIndexOf('.') + 1);
					// console.log(encodeURI(temp_url));
					// console.log(encodeURI(temp_filename));
					// console.log(temp_url);
					// console.log(this.file_name);
					// down_file.download = encodeURI(this.file_name); // 下载名称
					// down_file.href = encodeURI(temp_url) ; // 绑定a标签
					// down_file.click(); // 模拟点击实现下载

					// var a = document.createElement('a');
					// a.download = temp_filename;
					// a.href = encodeURI(temp_url);
					// $("body").append(a);
					// a.click();
					// $(a).remove();

					let postdata = '';
					postdata =
						'{"file_src":"' + temp_src + '","file_name":"' + temp_filename + '"}';

					postdata = base_encode(postdata);
					let that = this;
					this.$get(
						api.http_downfile,
						postdata
					).then(res => {
						that.saveFile(res, temp_filename);
					});

					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});
				}
			},
			saveFile: function(data, fileName) {
				var export_blob = new Blob([data]);
				var save_link = document.createElement('a');
				document.body.appendChild(save_link);
				save_link.style.display = 'none';
				var urlObject = window.URL.createObjectURL(export_blob);
				save_link.href = urlObject;
				save_link.download = fileName;
				save_link.click();
				document.body.removeChild(save_link);
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				console.log('点击删除附件');
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				postdata =
					'{"action":"' + 'data_del_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'"}';


				// console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					this.fun_d_load();
				});

			},
			fun_del_file_three: function() {
				// console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
					// console.log('小文件上传');
					this.fun_up_file_min();
				} else if (this.file_data.length > this.blockSize) {
					// console.log('大文件上传');
					// this.element_loading = true;
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";


				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					this.file_data +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.fun_d_load();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				// console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// console.log('上传长度=' + temp_data.size);
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";


				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					'","upfile_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","upfile_data":"' +
					'' +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'"}';


				// console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.fun_d_load();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.pretop {
		margin-top: 5px;
	}

	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_tb_detail {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_tb_detail td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		/* max-width: 256px; */
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
	}

	/* 首列是ID,不排序,隐藏 */
	.pre_tb_detail tr td:nth-child(1) {
		display: none;
	}

	.pre_tb_detail tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	/* 固定隐藏明细部分倒数第2、3列 */
	.pre_tb_detail tr td:nth-last-child(2),
	.pre_tb_detail tr td:nth-last-child(3) {
		display: none;
	}

	.pre_tb_detail tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_tb_detail td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* 表格内输入框 */
	.pre_tb_detail td input {
		width: 100%;
		height: 100%;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
	}

	.pre_tb_detail td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_tb_detail td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_tb_detail tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_tb_detail tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_tb_detail tr:hover {
		background-color: #b8f8b8 !important;
	}

	/*  .pre_tb_detail tr:focus {
    background: #92a4f3 !important;
  } */
	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		height: 100%;
		text-decoration: none;
		color: #333;
	}

	.pre_tb_detail tr>td>a:focus {
		background: #92a4f3 !important;
	}


	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: 5px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}


	.pre_tan_conten {
		position: fixed;
		width: 80%;
		height: auto;
		left: 10%;
		top: 5%;
		/* background: #faf5f5; */
		background-color: azure;
		border-radius: 5px;
		max-height: 90%;
		z-index: 30;
		overflow-y: auto;
		overflow-x: hidden;

	}

	.content_edit_item label {
		min-width: 108px;
	}

	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}
</style>